import React from "react";
import EngageTabs from "./EngageTabs/EngageTabs.component";

import "./Engage.style.css";

const Engage = () => {
  return (
    <>
      <section id="engage" className="engage py-3 top-nav-space">
        <div className="container px-0">
          <h1 className="text-center global-heading title-scroll">Engage</h1>
          <div className="engage-desc">
            <p className="mt-xl-4 px-2 text-black text-justify">
              Even small dedicated effort, whether of time, expertise, money or
              a word of recommendation makes a difference. Click below to join
              efforts in genetic diversity conservation, zero-impact
              agriculture, village economy, healthy living and cow care.
            </p>
          </div>
        </div>
      </section>
      <EngageTabs />
    </>
  );
};

export default Engage;
